import React, { useState } from "react";
import Select from "react-select";
import Modal from "react-modal";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { notify, formDataHelper } from "../../../../util/helpers";
import {
  inviteWalkInPatientLogic,
  invitedPatientLogic,
} from "../../../../store/features/patient/patientSlice";
import { DatePicker, DateRangePicker } from "rsuite";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import "../../patient/PatientStyles.css";
import moment from "moment";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "50%",
  },
};

const InviteWalkInPatient = ({ modalIsOpen, setIsOpen }) => {
  Modal.setAppElement("#root");
  const [loading, setLoading] = useState(false);
  const [dob, setDOB] = useState(null);
  const [nextAppointment, setNextAppointment] = useState(null);
  const { afterToday, beforeToday } = DateRangePicker;
  const { selectedClinic } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  function closeModal() {
    if (loading) {
      notify("Please wait while the patient is being invited", "info");
      return;
    }
    setIsOpen(false);
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      if (loading) {
        notify("Please wait while the patient is being invited", "info");
        return;
      }
      setLoading(true);
      const formData = new FormData(e.target);
      formData.append("date_of_birth", dob && moment(dob).format("YYYY-MM-DD"));
      formData.append(
        "next_appointment",
        nextAppointment && moment(nextAppointment).format("YYYY-MM-DD")
      );

      const data = formDataHelper(formData, true);
      data["clinic"] = selectedClinic?.clinic?.id;
      data["clinician"] = selectedClinic?.clinic_admin;

      inviteWalkInPatientLogic(data)
        .then((res) => {
          setLoading(false);

          if (res.status === 200) {
            dispatch(
              invitedPatientLogic({
                page_size: 999999,
                page: 1,
                status: "INVITED",
                clinic_id: selectedClinic?.clinic?.id,
                clinician_id: selectedClinic?.clinic_admin,
              })
            );
            notify("Patient invited successfully!");
            closeModal();
          } else {
            notify("Something went wrong! Try again later!", "error");
          }
        })
        .catch((e) => {
          setLoading(false);
          notify("Something went wrong! Try again later!", "error");
        });
    } catch (e) {
      setLoading(false);
      notify("Something went wrong! Try again later!", "error");
    }
  };
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
      >
        <div className="container-fluid">
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          <CardLayout className="p-3">
            <div className="w-100 pt-2 d-flex justify-content-start">
              <h3 className="primary-text-blue">Invite Walk-in Patient</h3>
            </div>
            <form onSubmit={handleSubmit} className="container-fluid p-1 row">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="form-group py-3">
                  <label>First Name *</label>
                  <input
                    required
                    name="first_name"
                    id="first_name"
                    placeholder="Enter First Name"
                  />
                </div>
                <div className="form-group py-3">
                  <label>Phone Number</label>
                  <input
                    name="cell_number"
                    id="cell_number"
                    maxLength={10}
                    minLength={10}
                    placeholder="Enter Phone Number"
                  />
                </div>
                <div className="form-group py-3">
                  <label>Date of Birth</label>
                  <DatePicker
                    placeholder="-- --"
                    appearance="subtle"
                    name="date_of_birth"
                    id="date_of_birth"
                    value={dob}
                    oneTap
                    onChange={setDOB}
                    caretAs={CalendarIcon}
                    shouldDisableDate={afterToday()}
                    format="MM/dd/yyyy"
                    className="custom-datepicker"
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="form-group py-3">
                  <label>Last Name *</label>
                  <input
                    required
                    name="last_name"
                    id="last_name"
                    placeholder="Enter Last Name"
                  />
                </div>
                <div className="form-group py-3">
                  <label>Email Address</label>
                  <input
                    type="email"
                    placeholder="Enter Email Address"
                    name="email"
                    id="email"
                  />
                </div>
                <div className="form-group py-3">
                  <label>Insurance</label>
                  <input
                    name="insurance"
                    id="insurance"
                    maxLength={14}
                    placeholder="Enter Insurance Number"
                  />
                </div>
              </div>
              <div className="form-group py-3">
                <label>Next Appointment Date</label>
                <DatePicker
                  placeholder="-- --"
                  appearance="subtle"
                  name="next_appointment"
                  id="next_appointment"
                  oneTap
                  value={nextAppointment}
                  onChange={setNextAppointment}
                  caretAs={CalendarIcon}
                  shouldDisableDate={beforeToday()}
                  format="MM/dd/yyyy"
                  className="custom-datepicker"
                />
              </div>
              {/* UNCOMMENT THIS WHEN YOU KNOW WHAT THIS DOES */}
              {/* <div className="form-group py-3 w-100">
                <label>BHI Diagnosis (if applicable)</label>
                <Select
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      border: "0px",
                      borderBottom: "1px solid #94A3B8",
                      borderRadius: "0px",
                      padding: "5px",
                    }),
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder="Invite Only"
                  classNamePrefix="select"
                  name="provider"
                  options={options}
                />
              </div> */}

              <div>
                {/* <div className="d-flex form-group my-2" style={{ gap: "10px" }}>
                  <input
                    type="checkbox"
                    required
                    style={{
                      border: "1px solid #D0D5DD",
                      borderRadius: "4px",
                      width: "23px",
                    }}
                  />
                  <small style={{ color: "#475569" }}>
                    I confirm I have discussed Behavioral Health Care Management
                    Program with the patient
                  </small>
                </div> */}

                {/* <div className="d-flex form-group my-2" style={{ gap: "10px" }}>
                  <input
                    type="checkbox"
                    required
                    style={{
                      border: "1px solid #D0D5DD",
                      borderRadius: "4px",
                      width: "20px",
                    }}
                  />
                  <small style={{ color: "#475569" }}>
                    I have informed the patient that they will be responsible
                    for potential cost sharing expenses for both in person and
                    non-face-to-face services.
                  </small>
                </div>

                <div className="d-flex form-group my-2" style={{ gap: "10px" }}>
                  <input
                    type="checkbox"
                    required
                    style={{
                      border: "1px solid #D0D5DD",
                      borderRadius: "4px",
                      width: "20px",
                    }}
                  />
                  <small style={{ color: "#475569" }}>
                    The patient has agreed to participate in the Behavioral
                    Health Care Program and for consultations to be conducted
                    with relevant specialists.
                  </small>
                </div> */}
              </div>
              <div
                className="container-fluid d-flex justify-content-end mt-3"
                style={{ gap: "30px" }}
              >
                <button
                  className="btn alternative-btn"
                  style={{ padding: "10px 20px", width: "20%" }}
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="primary-btn"
                  style={{ padding: "10px 20px !important", width: "20%" }}
                >
                  Send Invite
                </button>
              </div>
            </form>
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};

export default InviteWalkInPatient;
